{
    "webshop_offer_voucher_correctCode": "Πληκτρολογήθηκε σωστός κωδικός",
    "webShop_howToFindId_desc": "Μπορείς να βρεις και να αντιγράψεις το προσωπικό σου ID στο προφίλ παίκτη σου.",
    "webShop_howToFindId_link": "Πού μπορώ να βρω το προσωπικό μου αναγνωριστικό;",
    "webshop_offer_voucher_codeIsIncorrect": "Ο κωδικός είναι λανθασμένος",
    "webshop_offer_voucher_enterYourCode": "Πληκτρολόγησε το προσωπικό σου αναγνωριστικό",
    "webShop_unexpectedError_desc": "Προέκυψε μη αναμενόμενο σφάλμα, δοκίμασε ξανά αργότερα.",
    "webShop_accountBanned_desc": "Λογαριασμός αποκλείστηκε!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Όροι &amp; Προϋποθέσεις",
    "webshop_purchase_privacyPolicy": "Πολιτική απορρήτου",
    "webshop_legal_1": "Νομικές πληροφορίες",
    "webshop_support_1": "Υποστήριξη",
    "mbs_access_welcome_desc": "Καλώς όρισες, {0}",
    "btn_login": "Σύνδεση",
    "mbs_access_error_sessionExpired_desc": "Η περίοδος λειτουργίας έληξε. Πληκτρολόγησε το ID λογαριασμού σου μη αυτόματα."
}
